export const PW = {
  's': 'Secretary123',
  'm': 'Manager123'
};

export const USERTYPES = {
  SECRETARY: 'secretary',
  MANAGER: 'manager',
};